class PivotConfig {
    rowHeaderLayoutPivot: KnockoutObservable<number>;
    expandAllColumns: KnockoutObservable<boolean>;
    expandAllColumnsPrinting: KnockoutObservable<boolean>;
    enableFilterPanel: KnockoutObservable<boolean>;
    showColumnGrandTotals: KnockoutObservable<boolean>;
    showColumnTotals: KnockoutObservable<boolean>;
    showRowGrandTotals: KnockoutObservable<boolean>;
    showRowTotals: KnockoutObservable<boolean>;
    columnFieldsText: KnockoutObservable<ColumnFieldsTextPivotEnum>;
    separateFields: KnockoutObservable<boolean>;

    constructor(data: any) {
        this.rowHeaderLayoutPivot = ko.observable(data.rowHeaderLayoutPivot);
        this.expandAllColumns = ko.observable(data.expandAllColumns);
        this.expandAllColumnsPrinting = ko.observable(data.expandAllColumnsPrinting);
        this.enableFilterPanel = ko.observable(data.enableFilterPanel);
        this.showColumnGrandTotals = ko.observable(data.showColumnGrandTotals);
        this.showColumnTotals = ko.observable(data.showColumnTotals);
        this.showRowGrandTotals = ko.observable(data.showRowGrandTotals);
        this.showRowTotals = ko.observable(data.showRowTotals);
        this.columnFieldsText = ko.observable(data.columnFieldsText);
        this.separateFields = ko.observable(data.separateFields);
    }
}